module.exports = {"address":"0x84cf8df77edc4007b8da88880d85973fa77a1e47","abi":[{"constant":false,"inputs":[{"internalType":"uint256","name":"x","type":"uint256"}],"name":"set","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"get","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"}]}


//////////////////
// WEBPACK FOOTER
// ./contract.json
// module id = pXzk
// module chunks = 1